import { Component } from 'preact'
import WidgetV2Preview from '../components/widget-v2-preview';
import { LinkFilter, KeywordFilter, ThemeFilter } from '../components/filters';
import { __ } from '../../locales'

class V2AverageKeywordRating extends Component {
  render(props, state) {
    return (
      <WidgetV2Preview
        {...props}
        title={__('widget.treatment_banner.name')}
        description={__('widget.treatment_banner.description')}
        bestFor={[__('global.homepage'), __('global.footer')]}
        widgetName={'average-keyword-rating-widget'}
        extraParams={[
          'slugs',
        ]}
        requiredParams={['keyword']}
        badgeTitle={__('widget.type.banner')}
        badgeColor={'#FFC1BE'}
      >
        <div className={'filters-wrapper mt-5 mb-5'}>
          <ThemeFilter {...props} />
          <LinkFilter
              {...props}
              hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
          />
          <KeywordFilter required {...props} />
        </div>
      </WidgetV2Preview>
    );
  }
}

export default V2AverageKeywordRating
